"use strict";
/*
 * Created on 03 19 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var FamilyCreatedDTO_1 = require("../../model/dto/FamilyCreatedDTO");

var FamilyConverter_1 = require("../FamilyConverter");

var FamilyCreatedDTOConverter_1 = require("./FamilyCreatedDTOConverter");
/**
 * Implementation of {@link FamilyCreatedDTOConverter}. It is presumed that this converter will be used only for JSON API purposes.
 *
 * @author JMe
 */


var FamilyCreatedDTOConverterImpl =
/*#__PURE__*/
function (_FamilyCreatedDTOConv) {
  _inherits(FamilyCreatedDTOConverterImpl, _FamilyCreatedDTOConv);

  /**
   * @param familyConverter converter of {@link Family family}
   */
  function FamilyCreatedDTOConverterImpl(familyConverter) {
    var _this;

    _classCallCheck(this, FamilyCreatedDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FamilyCreatedDTOConverterImpl).call(this));
    _this.familyConverter = familyConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FamilyCreatedDTOConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        family: this.familyConverter.toDocument(source.family, conversions),
        affectedFamilies: conversions.asObjectArray(source, 'affectedFamilies', function (f) {
          return _this2.familyConverter.toDocument(f, conversions);
        })
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new FamilyCreatedDTO_1.FamilyCreatedDTO(FamilyCreatedDTO_1.FamilyCreatedDTO.schema.family.valueOfField(source), FamilyCreatedDTO_1.FamilyCreatedDTO.schema.affectedFamilies.valueOfField(source));
    }
  }]);

  return FamilyCreatedDTOConverterImpl;
}(FamilyCreatedDTOConverter_1.FamilyCreatedDTOConverter);

FamilyCreatedDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [FamilyConverter_1.FamilyConverter])], FamilyCreatedDTOConverterImpl);
exports.FamilyCreatedDTOConverterImpl = FamilyCreatedDTOConverterImpl;